module.exports = __webpack_public_path__ + "media/6.c00aecd6.mp3";